module.exports = __webpack_public_path__ + "assets/img/help_pagination03-2.53c53c9d.svg";